import { UseStore } from '@eastcoal/common/types/zustand'
import { useShallowStore } from '@eastcoal/common/utils/zustand'

import { authStore } from '../../store'
import { AuthStore } from '../../store/interface'

export const useAuthStore: UseStore<AuthStore> = selector => {
  return useShallowStore(authStore, selector)
}

export const useAuthStoreApi = () => {
  return authStore
}
